<template>
<div id="bundles">
  <bundle-nav></bundle-nav>

  <pagination
    :resourceUrl="this.apiUrl('/puzzle_bundles', true)"
    :pageSize="$root.defaultPageSize"
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{ name: 'bundle', params: { bundleId: item.id }}">
        {{ item.name }}
      </router-link>
    </template>
  </pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import BundleNav from '@/components/BundleNav'

import BundlesStore from '@/stores/BundlesStore'

export default {
  data () {
    return BundlesStore.state
  },

  components: {
    'bundle-nav': BundleNav,
    pagination: Pagination
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Bundles.vue